import { BundleType } from '@order/orderTypes'
import { useCustomer, useStore } from 'hooks/useSession'
import { useDealByBundleType } from '../useDeal'
import { getValuesDefaults } from './OrderValues'

export const useOrderDefaults = (bundleType: BundleType) => {
  const customer = useCustomer()
  const store = useStore()

  const deals = useDealByBundleType()
  const deal = bundleType ? deals[bundleType] : deals.base
  return getValuesDefaults({
    dealCode: deal?.code,
    dealType: deal?.type ?? 'normal',
    frames: deal?.frames,
    customer,
    store,
  })
}
